// extracted by mini-css-extract-plugin
export default {"Container":"Depositions_Container__qKHn6","Box":"Depositions_Box__LIGZu"};